import React from 'react';
import Menubar from './Menubar';
import Footer from './Footer';
import HomePage1 from './HomePage1';


export default function Home() {
    return (
        <>
            <Menubar />
            <HomePage1/>
           
            <Footer />

        </>
    )
}